// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"bfd28dc1816ea9e9dc00","293":"724bb494462bf1f1e5b6"}[chunkId] + ".js";
};